import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';

import Modal from '../Modal.jsx';

import './CountryChoiceModal.scss';

export default class CountryChoiceModal extends Modal {
  static propTypes = {
    alternativeUrl: PropTypes.string,
    message: PropTypes.string,
  };

  static defaultProps = {
    alternativeUrl: null,
    message: null,
  };

  render() {
    const {alternativeUrl, message} = this.props;

    if (alternativeUrl === null) {
      return null;
    }

    return <BootstrapModal
      backdrop="static"
      className="modal-lg"
      isOpen={this.props.isOpen}
      toggle={this.props.closeModal}
    >
      <ModalHeader toggle={this.props.closeModal}>Choix du pays</ModalHeader>
      <ModalBody>
        <p className="text-center">{message}</p>
        <div className="d-flex flex-wrap justify-content-center actions">
          <a href={alternativeUrl} className="btn btn-primary">
            Se rendre sur {(new URL(alternativeUrl)).hostname.replace(/www\./, '')}
          </a>
          <Button outline={true} color="secondary" onClick={this.props.closeModal}>
            Continuer sur le site actuel
          </Button>
        </div>
      </ModalBody>
    </BootstrapModal>;
  }
}
